<div class="state-modal">
  <div class="modal-dialog state-modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">Envoie d'un SMS</h2>
      </div>
      <div class="modal-body">

        <div class="ordonnance-etat-container">
          <form *ngIf="smsClientForm" [formGroup]="smsClientForm" (ngSubmit)="onSubmit()">
            <div class="row process-row process-message">
              <div class="col-md-12">
                <label>Message a envoyer sur le téléphone du client :</label>
                <p>(Messages SMS limités a 160 caractères max)</p>
                <textarea rows="5" formControlName="message"></textarea>
              </div>
              <div *ngIf="submitted && field.message.errors" class="invalid-feedback">
                <div *ngIf="field.message.errors.required">Le message est requis</div>
              </div>
            </div>
            <div class="row process-row process-bal">
              <div class="col-md-12"><input formControlName="copyMail" type="checkbox" id="check-bal" /><label for="check-bal">Envoyer une copie dans ma BAL</label></div>
            </div>
          </form>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger btn-giphar" (click)="closeModal()">Annuler</button>
        <button type="button" class="btn btn-info btn-rejetee" [disabled]="buttonDisabled" (click)="sendForm()">Envoyer Message</button>
      </div>
    </div>
  </div>
</div>




